import React, { useState } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { Box } from '@fiverr-private/theme';
import { ArrowRightIcon, ComplianceServicesL2Icon, SpinnerL1Icon } from '@fiverr-private/visuals';
import { translate } from '@fiverr-private/i18n-react';

const UpgradeRequestModalButton = ({ onClick }: { onClick: () => void }) => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <Stack
            direction="row"
            alignItems="center"
            gap="2"
            onClick={() => {
                setIsLoading(true);
                onClick?.();
            }}
            cursor={'pointer'}
        >
            <Text size="b_sm" fontWeight="semibold">
                {translate('upsell.upgrade_suggestion.request_upgrade')}
            </Text>
            {isLoading ? <SpinnerL1Icon size="sm" color="grey_1200" /> : <ArrowRightIcon size="sm" color="grey_1200" />}
        </Stack>
    );
};

export const UpgradeSuggestion = ({ onClickUpgrade, body }: { onClickUpgrade: () => void; body: string }) => (
    <Box borderRadius="lg" borderColor="grey_400" borderWidth="sm" paddingY="1" borderStyle="solid" width="100%">
        <Stack display="inlineFlex" padding="6" gap="4">
            <Box>
                <ComplianceServicesL2Icon size="lg" />
            </Box>
            <Stack direction="column" gap="2" alignItems="flexStart" width="100%">
                <Text size="b_sm">{body}</Text>
                <UpgradeRequestModalButton onClick={onClickUpgrade} />
            </Stack>
        </Stack>
    </Box>
);
